<template>
  <div class="bank-account-container">
    <Breadcrumb :company="company_uid" :project="projectUID" lastname="Bank Account Project"/> 
    <BankAccountManager v-if="projectUID" :projectUID="projectUID" :customerUID="customerUID" :readonlyMode="bankRole" apiMode="project"/>
    <el-card class="box-card" v-if="!projectUID">
      <el-alert
        title="Error alert"
        type="error"
        description="Pleace select your project"
        show-icon
        :closable="false">
      </el-alert>
      <el-button @click="$router.push('/project')" type="primary">Select your Project</el-button>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BankAccountManager from '@/views/bank-account/components/bank-account-manager'
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components:{
    BankAccountManager,
    Breadcrumb
  },
    computed:{
    ...mapGetters(['user_project', 'company_uid']),
    bankRole(){
      return this.roleAuth([this.role.admin, this.role.user])
    }
  },
  data(){
    return {
      projectUID: "",
      customerUID: ""
    }
  },
  created(){
      this.projectUID = this.user_project

  }
}
</script>

<style>

</style>